import React, { useMemo } from 'react';
import { useModalWatch } from '../../../../shared/packages/modalManager';
import { modalNames } from '../../../../shared/configs/modal';
import { fieldNames } from '../../constants';
import { roomAttachmentTypeIds } from '../../../../shared/configs/attachments';
import { FormControllerProvider } from '../../../../../../helpers/formManager';

export const FormProvider = ({ children }) => {
  const hasRecord = useModalWatch({
    name: modalNames.attachmentsForm,
    selector: (state) => Boolean(state?.props?.record),
  });

  const options = useMemo(() => {
    return hasRecord
      ? undefined
      : { values: { [fieldNames.typeId]: roomAttachmentTypeIds.acceptance } };
  }, [hasRecord]);

  return (
    <FormControllerProvider options={options}>
      {children}
    </FormControllerProvider>
  );
};
